import { For, Show, createSignal } from "solid-js";
import type { Component } from "solid-js";
import { useShellStore } from "@ui/state/shell";

export const PanelStack: Component = () => {
  const {
    state,
    actions: { closePanel },
  } = useShellStore();

  // Track which panel is active on mobile (0 = first panel, 1 = second panel, etc.)
  const [activeMobilePanelIndex, setActiveMobilePanelIndex] = createSignal(0);

  // When panels change, show the last one by default
  const getActivePanelIndex = () => {
    const index = activeMobilePanelIndex();
    const maxIndex = state.panelStack.length - 1;
    // If index is out of bounds, show the last panel
    return index > maxIndex ? maxIndex : index;
  };

  const toggleMobilePanel = () => {
    const currentIndex = getActivePanelIndex();
    // Toggle between 0 and 1 (first and second panel)
    setActiveMobilePanelIndex(currentIndex === 0 ? 1 : 0);
  };

  return (
    <div class="panel-stack" aria-label="Detail panels">
      <Show when={state.panelStack.length > 0}>
        <For each={state.panelStack}>
          {(panel, index) => {
            const isActive = () => index() === getActivePanelIndex();
            const hasMultiplePanels = () => state.panelStack.length > 1;

            return (
              <section
                class="detail-panel"
                classList={{ "is-active-mobile": isActive() }}
                role="complementary"
              >
                <header class="detail-panel-header">
                  <span>{panel.title}</span>
                  <div class="panel-header-actions">
                    {/* Toggle button - only visible on mobile when multiple panels open */}
                    <Show when={hasMultiplePanels()}>
                      <button
                        type="button"
                        class="panel-toggle-btn mobile-only"
                        aria-label="Switch panel"
                        onClick={toggleMobilePanel}
                        title={`Switch to ${index() === 0 ? 'next' : 'previous'} panel`}
                      >
                        <i class="fa-solid fa-arrow-right-arrow-left"></i>
                      </button>
                    </Show>
                    <button
                      type="button"
                      class="panel-close-btn"
                      aria-label={`Close ${panel.title}`}
                      onClick={() => closePanel(panel.id)}
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </header>
                <div class="detail-panel-content">
                  {panel.body()}
                </div>
              </section>
            );
          }}
        </For>
      </Show>
    </div>
  );
};

